export default __webpack_public_path__ + "static/SiemensSans-Black-eb1a4396440c9a781a2b2fe6af2e1735.woff2";